import { useEffect, useRef } from "react";

export const useRingtone = (shouldRing) => {
    const ringToneRef = useRef(null);

    const startRingTone = () => {
        if (ringToneRef.current) return;

        const playBeep = () => {
            try {
                const AudioContext = window.AudioContext || window.webkitAudioContext;
                if (!AudioContext) return;

                const ctx = new AudioContext();
                const osc = ctx.createOscillator();
                const gain = ctx.createGain();

                osc.type = "sine";
                osc.frequency.setValueAtTime(880, ctx.currentTime); // High pitch notification
                osc.connect(gain);
                gain.connect(ctx.destination);

                gain.gain.setValueAtTime(0.1, ctx.currentTime);
                gain.gain.exponentialRampToValueAtTime(0.00001, ctx.currentTime + 0.5);

                osc.start();
                osc.stop(ctx.currentTime + 0.5);

                // Cleanup context after sound prevents leak
                setTimeout(() => {
                    if (ctx.state !== 'closed') ctx.close();
                }, 600);
            } catch (err) {
                console.warn("Ringtone playback failed", err);
            }
        };

        playBeep(); // Immediate
        const interval = setInterval(playBeep, 2000); // Loop
        ringToneRef.current = interval;
    };

    const stopRingTone = () => {
        if (ringToneRef.current) {
            clearInterval(ringToneRef.current);
            ringToneRef.current = null;
        }
    };

    useEffect(() => {
        if (shouldRing) {
            startRingTone();
        } else {
            stopRingTone();
        }
        return () => stopRingTone();
    }, [shouldRing]);
};
